import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const _getters = {
    getSections: state => {
        return state.sections
    },
    getPages: state => {
        return state.pages
    },
    getProjects: state => {
        return state.projects
    }
}

const store = new Vuex.Store({
    state: {
        sections: [],
        pages: [],
        projects: []
    },
    mutations: {
        sections (state, sections) {
            state.sections = sections
        },
        pages (state, pages) {
            state.pages = pages
        },
        projects (state, projects) {
            state.projects = projects
        }
    },
    getters: _getters
})

export default store
